module.exports = __webpack_public_path__ + "static/media/illuEuropraid2018_02_full.f9b82412.png";